import { Typography } from "antd";
import { CampaignRequirementsProps,  } from "./campaign-requirements-types";
import RequiredNFT from "./components/required-nft/required-nft";

const COMPONENTS = {
  GET_NFT: RequiredNFT
}

const EXTRACT_KEY = 'COLLECTION_';
const CampaignRequirements: React.FC<CampaignRequirementsProps> = ({ objective, setArrayCompletedRequirements, position }) => {
  const { type } = objective;
  const newType = type?.split(':')?.[0];
  const collectionKey = type?.split(EXTRACT_KEY)?.[1];
  const Component = COMPONENTS[newType as keyof typeof COMPONENTS] || null;

  if (!Component) {
    return <Typography.Text>Not supported objective type</Typography.Text>
  }

  return (
    <Component 
      collectionKey={collectionKey} 
      objective={objective}
      setArrayCompletedRequirements={setArrayCompletedRequirements}
      position={position}
    /> 
  )
}

export default CampaignRequirements;
